<template>
  <div class="mt-20 text-center p-4 mx-auto w-1/2">
    <p class="text-lg">
      {{ $t('home.welcome') }}
    </p>
    <div class="mt-8">
      <div class="flex items-center">
        <div>
          <input
            id="checkbox"
            v-model="checked"
            class="h-6 w-6"
            type="checkbox"
          >
        </div>
      <div class="ml-2 flex-1 text-left">
          <label for="checkbox">
            Dichiaro di aver preso visione e di accettare integralmente il
            <a
              class="underline text-corepla-text"
              target="_blank"
              href="https://assets.astecorepla.com/regolamento-it.pdf"
            >Regolamento Aste Telematiche Corepla.</a>
          </label>
          <br>
          <label for="checkbox">
            I declare that I have read and fully accept the
            <a
              class="underline text-corepla-text"
              target="_blank"
              href="https://assets.astecorepla.com/regolamento-en.pdf"
            >Regulation for Corepla Online Auctions.</a>
          </label>
        </div>
      </div>
    </div>
    <p class="mt-12">
      <a
        v-if="checked"
        href="#"
        class="bg-corepla-dark text-white font-bold rounded p-2 m-4 inline-block"
        @click.prevent="handleLogin"
      >{{ $t('home.login') }}</a>
    </p>
  </div>
</template>

<script setup>
import { useAuth0 } from "@auth0/auth0-vue";
import { ref } from 'vue'

const { loginWithRedirect, } = useAuth0();

const checked = ref(false);

const handleLogin = () => {
  loginWithRedirect({
    appState: {
      target: "/login",
    },
  });
};
</script>

